export default __webpack_public_path__ + "static/media/DNo.38-2.b1fd95fc.jpg";